// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"728":"38cc21e9","854":"abaa1252"}[chunkId] + ".chunk.js";
};